/* eslint-disable max-len */
const HeadSVG = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 64 64"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
        // stroke: "black",
        // fill: "#6764d7",
      }}
    >
      <g className="head-svg" transform="matrix(1,0,0,1,0,-896)">
        <path
          className="svg-background"
          d="M24,950L24,935L15,926L15,916L18,916L18,909L26,905L45,905L53,912L53,923L43,933L43,950L45,950L45,953.5L44.5,954L22.5,954L22,953.5L22,950L24,950Z"
          style={{ fillOpacity: 0.76 }}
        />
        <path
          className="color_01"
          d="M41.5,954L38.5,954L38.5,952C38.5,951.448 38.052,951 37.5,951L36.5,951C35.948,951 35.5,951.448 35.5,952L35.5,954L30.5,954L30.5,952C30.5,951.448 30.052,951 29.5,951L28.5,951C27.948,951 27.5,951.448 27.5,952L27.5,954L25.5,954L25.5,952C25.5,951.448 25.052,951 24.5,951L23.5,951C22.948,951 22.5,951.448 22.5,952L22.5,954L20,954L20,949C20,948.448 20.448,948 21,948L45,948C45.552,948 46,948.448 46,949L46,954L44.5,954L44.5,952C44.5,951.448 44.052,951 43.5,951L42.5,951C41.948,951 41.5,951.448 41.5,952L41.5,954ZM25,943L29,943L32,940L41,940C42,940 42,941 42,941L42,946L25,946L25,943ZM12,927C12,927 11.992,926 12.996,926L38,926L38,918C38,918 38,917 39,917L46,917C47,917 47,918 47,918L47,923C47,924 46,924 46,924L44,924L27,941L24,941L12,929L12,927ZM34,938L44,928L46,928L50,924L50,921C50,921 50,920 51,920L53,920L53,927L42,938L34,938ZM43.5,919C44.328,919 45,919.672 45,920.5C45,921.328 44.328,922 43.5,922C42.672,922 42,921.328 42,920.5C42,919.672 42.672,919 43.5,919ZM35,917C35,917 38,913 42.5,913C47,913 50,917 50,917L53,914.5C53,914.5 47,909 42.5,909L18,909C17,909 15,911 15,912L15,916C15,916 15,917 16,917L35,917ZM22,907C22,907 26,902 29,902L42.5,902C46.5,902 53,912 53,912C53,912 45.5,907 42.5,907L22,907Z"
          // style={{ fill: "#6764d7" }}
        />
        <path
          className="color_02"
          d="M33,945C33,944.448 32.552,944 32,944L31,944C30.448,944 30,944.448 30,945L30,946L33,946L33,945ZM37,945C37,944.448 36.552,944 36,944L35,944C34.448,944 34,944.448 34,945L34,946L37,946L37,945ZM41,945C41,944.448 40.552,944 40,944L39,944C38.448,944 38,944.448 38,945L38,946L41,946L41,945ZM29,945C29,944.448 28.552,944 28,944L27,944C26.448,944 26,944.448 26,945L26,946L29,946L29,945Z"
          // style={{ fill: "#6764d7" }}
        />
      </g>
    </svg>
  );
};

export default HeadSVG;
